<template>
  <div>
    <el-link class="link-content" :underline="false" @click.stop.prevent="getMyAward">中奖记录</el-link>
  </div>
  <div class="grid-box">
    <div class="grid-toolTip">
      <!--      <div class="grid-toolTip-btn" v-if="!isEdit">-->
      <!--        <el-button-->
      <!--          type="primary"-->
      <!--          icon="el-icon-lock"-->
      <!--          circle-->
      <!--          @click="beginEdit"-->
      <!--        ></el-button>-->
      <!--      </div>-->
      <div class="grid-toolTip-btn" v-if="isEdit">
        <el-button
          type="primary"
          icon="el-icon-plus"
          circle
          @click="addItem"
        ></el-button>
      </div>
      <div class="grid-toolTip-btn" v-if="isEdit">
        <el-button
          type="primary"
          icon="el-icon-check"
          circle
          @click="saveItem"
        ></el-button>
      </div>
    </div>
    <grid-layout
      ref="gridLayout"
      v-model:layout="layout"
      :col-num="colNum"
      :row-height="30"
      :is-draggable="isEdit"
      :is-resizable="isEdit"
      :is-mirrored="false"
      :vertical-compact="true"
      :margin="[10, 10]"
      :use-css-transforms="true"
      :preventCollision="true"
    >
      <grid-item
        ref="gridItem"
        v-for="item in layout"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
        :key="item.i"
      >
        <div class="grid-item-div">
          <i
            v-if="isEdit"
            class="el-icon-close"
            @click="delItem(item.i)"
            style="
              position: absolute;
              top: 5px;
              right: 5px;
              font-size: 16px;
              cursor: pointer;
            "
          />
          <component
            :is="item.component"
            :options="item.options"
            style="width: 100%; height: 100%"
          />
        </div>
      </grid-item>
    </grid-layout>

    <div class="itemModal" style="position:fixed; z-index: 10">
      <el-dialog
        :title=awardDialogTitle
        v-model="awardDialogVisible"
        width="40%"
        center
        destroy-on-close
        v-on:closed="awardDialogClose"
      >
        <lf-table
          :listData="awardDataList"
          :listCount="awardDataCount"
          :title="awardTableTitle"
          v-bind="customerTableConfig"
          v-model:page="awardPageInfo"
        >
          <template #receiveStatus="scope">
            <el-tag v-if="scope.row.receiveStatus === 0" size="mini" type="primary">未领取</el-tag>
            <el-tag v-else-if="scope.row.receiveStatus === 1" size="mini" type="success">已领取</el-tag>
          </template>
        </lf-table>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import {getCurrentInstance, onMounted, ref, watch} from 'vue'
import FastMenuButton from '../../../components/FastMenuButton'
import DailyAchievement from '../../../components/DailyAchievement'
import Raffle from '../../../components/Raffle'
import RaffleRecord from '../../../components/RaffleRecord'
import RankingList from '../../../components/RankingList'
import ExchangeEchart from '../../../components/ExchangeEchart'
import {customerTableConfig} from '../../../components/config/raffle.content.config'
import { getListData } from '../../../service/main/system'
import {useStore} from "@/store";
import LfTable from "@/components/LfTable";

const { proxy } = getCurrentInstance()
const isEdit = ref(false)
const layout = ref([
  {
    x: 0,
    y: 0,
    w: 6,
    h: 2,
    i: '0',
    component: FastMenuButton,
    options: { title: '通话统计', link: '/main/voice/statistic' }
  },
  {
    x: 6,
    y: 0,
    w: 6,
    h: 2,
    i: '1',
    component: FastMenuButton,
    options: {
      title: '沟通计划表',
      link: '/main/report/preSaleCommPlan',
      link518: '/main/report/preSaleCommPlan518'
    }
  },
  {
    x: 12,
    y: 0,
    w: 6,
    h: 2,
    i: '2',
    component: FastMenuButton,
    options: { title: '直播链接管理', link: '/main/live/channel' }
  },
  {
    x: 18,
    y: 0,
    w: 6,
    h: 2,
    i: '3',
    component: FastMenuButton,
    options: { title: '视频管理', link: '/main/fubo/video' }
  },
  { x: 0, y: 2, w: 8, h: 10, i: '4', component: RankingList },
  { x: 8, y: 2, w: 8, h: 10, i: '5', component: Raffle },
  { x: 16, y: 2, w: 8, h: 10, i: '6', component: RaffleRecord },
  { x: 0, y: 12, w: 14, h: 10, i: '7', component: ExchangeEchart },
  { x: 14, y: 12, w: 10, h: 10, i: '8', component: DailyAchievement }
])
const colNum = ref(24)
const awardDialogVisible = ref(false)
const awardDialogTitle = ref('')
const awardTableTitle = ref('');
const awardDataList = ref([])
const awardDataCount = ref(0)
const awardPageInfo = ref({pageNo: 1, pageSize: 10})
let awardQueryItemInfo = {userId: -1, pageNo: 1, pageSize: 10}

const store = useStore()
const userInfo = store.state.login.userInfo

// 获取我的奖品
const getMyAward = () => {
  awardDialogVisible.value = true;
  awardTableTitle.value = '中奖记录'
  getMyAwardData(userInfo.id)
}

// 获取我的奖品数据
const getMyAwardData = async(userId) => {
  awardQueryItemInfo = {
    userId: userId,
    pageNo: awardPageInfo.value.pageNo,
    pageSize:  awardPageInfo.value.pageSize
  }
  const data = await getListData('/main/raffleRecord/getRecordByEmpId', awardQueryItemInfo)
  awardDataList.value = data.list
  awardDataCount.value = Number(data.total)
}

const awardDialogClose = () => {
  awardDataList.value = [];
  awardPageInfo.value.pageNo = 1;
  awardPageInfo.value.pageSize = 10;
  awardDataCount.value = 0;
}
watch(awardPageInfo, () => getMyAwardData(userInfo.id))

const beginEdit = () => {
  isEdit.value = true
}

const updateFastMenu = () => {
  getListData('/main/topHit/getTopHit').then((res) => {
    res.forEach((o, index) => {
      layout.value[index].options = {
        title: o.name,
        link: o.uri
      }
    })
  })
}

onMounted(() => {
  updateFastMenu()
})

const addItem = () => {
  console.log('addItem')

  // 初始位置
  let newX = 0
  let newY = 0

  // 如果布局为空，则设置初始位置
  if (layout.value.length === 0) {
    newX = 0
    newY = 0
  } else {
    // 获取最后一个框的坐标
    const lastItem = layout.value[layout.value.length - 1]

    // 计算新框的坐标
    newX = (lastItem.x + lastItem.w) % colNum.value // 假设每个框宽度为2，横向偏移2
    newY =
      Math.floor((lastItem.x + lastItem.w) / colNum.value) * lastItem.h +
      lastItem.y
  }

  // 添加新框
  layout.value.push({
    x: newX,
    y: newY,
    w: 4,
    h: 2,
    i: layout.value.length.toString()
  })
  console.log(layout.value)
}

const delItem = (i) => {
  console.log('delItem')
  const index = layout.value.findIndex((item) => item.i === i)
  layout.value.splice(index, 1)
  console.log(layout.value)
}

const saveItem = () => {
  isEdit.value = false
}
</script>

<style scoped lang="less">
.grid-box {
  width: 100%;
  height: 885px;
}
.grid-toolTip {
  position: fixed;
  top: 100px;
  right: 30px;
  display: flex;
  flex-direction: column;
  z-index: 99;
  .grid-toolTip-btn {
    margin-bottom: 10px;
  }
}

.grid-item-div {
  width: 100%;
  height: 100%;
  //border: 1px solid #55b9da;
  display: flex;
  position: relative;
}

.link-content {
  font-size: 12px;
  color: #1275c4;
  position: fixed;
  top: 28%;
  right: 32%;
  z-index: 10;
  text-decoration: underline !important;
}
</style>
